import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

export function usePutDataset({ callApiWithWorker, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["updateDataset"],

    mutationFn: async ({ id, payload }) => {
      if (!id) throw new Error("Dataset id is required to update a dataset");

      const res = await callApiWithWorker(`/datasets/${encodeURIComponent(id)}`, {
        method: "PUT",
        body: payload,
      });

      const status =
        res?.statusCode ??
        res?.data?.statusCode ??
        res?.status ??
        res?.data?.status;

      if (typeof res?.ok === "boolean" && !res.ok) {
        const e = new Error(`Update failed (${status ?? "unknown"})`);
        e.statusCode = status;
        e.response = res;
        throw e;
      }

      if (status && status >= 400) {
        const e = new Error(`Update failed (${status})`);
        e.statusCode = status;
        e.response = res;
        throw e;
      }

      return res;
    },

    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ["datasets"] });
      queryClient.invalidateQueries({ queryKey: ["dataOfferings"] });

      if (vars?.id) {
        queryClient.invalidateQueries({ queryKey: ["dataset", vars.id] });
      }

      showSuccessToast(t("updateSubMessage"), {
        title: t("updateMessage"),
      });
      vars?.onDone?.();
    },

    onError: (error) => {
      showErrorAlert(error, t);
    },
  });
}
